import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	sectionTitle: {
		id: 'fastshift.dc-instance-details.top-recommendation.section-title',
		defaultMessage: 'Recommendations',
		description: 'Heading for the recommendations section on the DC instance details page',
	},
	sectionDescription: {
		id: 'fastshift.dc-instance-details.top-recommendation.section-description',
		defaultMessage:
			'{recommendationCount, plural, one {# check has recommendations.} other {# checks have recommendations.}} Start with the recommendation below, or use the “Needs attention” filter in Results to explore recommendations. We’ll re-check these results at the next assessment.',
		description: 'Guidance shown above the top recommendation card',
	},
	startHere: {
		id: 'fastshift.dc-instance-details.top-recommendation.start-here',
		defaultMessage: 'Start here',
		description: 'Label identifying the first recommendation to address',
	},
	recommendationPosition: {
		id: 'fastshift.dc-instance-details.top-recommendation.position',
		defaultMessage: '1 of {recommendationCount}',
		description: 'Position of the displayed recommendation within all recommendations',
	},
	viewFullDetails: {
		id: 'fastshift.dc-instance-details.top-recommendation.view-full-details',
		defaultMessage: 'View full details',
		description: 'Button label for opening the recommendation details panel',
	},
	emptyState: {
		id: 'fastshift.dc-instance-details.top-recommendation.empty-state',
		defaultMessage: 'There are no active recommendations.',
		description: 'Message shown when an assessment has no active top recommendation',
	},
	loadingLabel: {
		id: 'fastshift.dc-instance-details.top-recommendation.loading-label',
		defaultMessage: 'Loading recommendations',
		description: 'Accessible label for the recommendations loading indicator',
	},
});
